module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg1.c90d1e40.jpg";